// stati, fonti e social dei post del piano social, comuni a lista e scheda
import moment from 'moment';

export const STATI = {
	BOZZA: { label: 'Bozza', colore: 'grey', icona: 'mdi-pencil-outline' },
	PROGRAMMATO: { label: 'Programmato', colore: 'info', icona: 'mdi-calendar-clock' },
	IN_PUBBLICAZIONE: { label: 'In pubblicazione', colore: 'warning', icona: 'mdi-progress-upload' },
	PUBBLICATO: { label: 'Pubblicato', colore: 'success', icona: 'mdi-check-circle-outline' },
	ERRORE: { label: 'Non pubblicato', colore: 'error', icona: 'mdi-alert-circle-outline' },
	ANNULLATO: { label: 'Annullato', colore: 'grey darken-1', icona: 'mdi-cancel' },
};

export const FONTI = {
	viewed: { label: 'Più visti', icona: 'mdi-eye-outline' },
	sold: { label: 'Più venduti', icona: 'mdi-trending-up' },
	new: { label: 'Nuovi', icona: 'mdi-new-box' },
	offer: { label: 'In offerta', icona: 'mdi-sale' },
	catalog: { label: 'Dal catalogo', icona: 'mdi-shuffle-variant' },
	manual: { label: 'Scelto a mano', icona: 'mdi-hand-pointing-right' },
};

export const SOCIAL = {
	facebook: { label: 'Facebook', icona: 'mdi-facebook', colore: '#1877F2' },
	instagram: { label: 'Instagram', icona: 'mdi-instagram', colore: '#E1306C' },
	tiktok: { label: 'TikTok', icona: 'mdi-music-note', colore: '#111111' },
};

export function stato(s) {
	return STATI[s] || { label: s || '—', colore: 'grey', icona: 'mdi-help-circle-outline' };
}

export function fonte(s) {
	return FONTI[s] || FONTI.manual;
}

// "tra 3 giorni", "oggi", "3 giorni fa"
export function quando(d) {
	if (!d) return '';
	const giorni = moment(d).startOf('day').diff(moment().startOf('day'), 'days');
	if (giorni === 0) return 'oggi';
	if (giorni === 1) return 'domani';
	if (giorni === -1) return 'ieri';
	return giorni > 0 ? `tra ${giorni} giorni` : `${-giorni} giorni fa`;
}

// un post pubblicato o in pubblicazione non si modifica piu'
export function modificabile(item) {
	return !!item && !['PUBBLICATO', 'IN_PUBBLICAZIONE'].includes(item.status);
}

export function scaricaBlob(blob, nome) {
	const href = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = href;
	a.download = nome;
	document.body.appendChild(a);
	a.click();
	a.remove();
	setTimeout(() => URL.revokeObjectURL(href), 1000);
}
